import React from "react";
import { Field, reduxForm } from "redux-form";
import {database} from "../app-database";

class ContratoDatosForm extends React.Component{

	state = {
		confidencialidad : "",
		isMobile: window.innerWidth <= 760,
	}

	handleWindowResize = () => {
		this.setState({ isMobile: window.innerWidth <= 760 });
	}

	componentDidMount() {
		window.addEventListener('resize', this.handleWindowResize);
	}


	componentWillMount = () =>{
		window.removeEventListener('resize', this.handleWindowResize);

		var $this = this;
		database.ref("/documentacion/contrato").once("value").then(function(data){
			$this.setState({ "confidencialidad" : data.val() });
		});

		window.scrollTo(0,0);
	}

	cancelar = () => {
		this.props.change("acepto", false);
		this.props.handleSubmit(values => this.props.onSubmit({ ...values, acepto: false }))();
	}

	aceptar = () => {
		this.props.change("acepto", true);
		this.props.handleSubmit(values => this.props.onSubmit({ ...values, acepto: true }))();
	}

	render() {
		const { confidencialidad } = this. state;
		const newConfidencialidad = confidencialidad.replace(/<p>___________________________________________________/g,'');
		const { handleSubmit, submitting } = this.props;
		const { isMobile } = this.state;
		return (
			<form onSubmit={handleSubmit}>
				<div className="contratos-wrap mt-10">
					<h3 className="title-contract">Datos Personales y consentimiento.</h3>
					<div className="content-scroll">
						<div dangerouslySetInnerHTML={{__html: newConfidencialidad}} className="txt-gray"></div>
					</div>
				</div>

				{isMobile ?
				<div className="container margin-buttons-movile-contracts">
					<div className="row" >
						<div className="registro-button-container">
							<div className="col-md-12 col-sm-12 col-xs-12">
									<button type="button" onClick={this.aceptar} className="pure-material-button-contained btn-full-width">Sí consiento</button>
							</div>
						</div>
					</div>
					<div className="row" >
						<div className="registro-button-container">
							<div className="col-md-12 col-sm-12 col-xs-12">
									<button type="button" onClick={this.cancelar} className="pure-material-button-outlined-registro btn-full-width">No consiento</button>
							</div>
						</div>
					</div>
				</div>
				:
				<div className="datos-wrap">
					<div className="row btn-bottom">
						<div className="col-md-6 col-sm-6 col-xs-12">
							<button type="button" onClick={this.cancelar} className="orange-rectangle disabled" style={{"marginBottom":"10px","width":"158px"}}>No consiento</button>
						</div>
						<div className="col-md-6 col-sm-6 col-xs-12">
							<button type="button" onClick={this.aceptar} className="orange-rectangle disabled" style={{"width":"158px"}}>Sí consiento</button>
						</div>
					</div>
				</div>
				}
		
				<Field name="acepto" component="input" type="hidden" />
			</form>
		);
	}
}

export default ContratoDatosForm = reduxForm({form: "confidencialidad"})(ContratoDatosForm);


// WEBPACK FOOTER //
// ./src/gnp-registro-seguridad/contrato-datos.frm.js